import { TransactionTypeEnum } from 'enum/common';

interface ITransactionTypeProps {
  type: TransactionTypeEnum;
}
const TransactionType: React.FC<ITransactionTypeProps> = ({ type }) => {
  switch (type) {
    case TransactionTypeEnum.EARNED:
      return (
        <h2 color="blue-gray" className="font-normal items-center flex flex-row">
          Claimed
        </h2>
      );

    case TransactionTypeEnum.TOP_UP:
      return (
        <h2 color="blue-gray" className="font-normal items-center flex flex-row">
          Top-up
        </h2>
      );

    case TransactionTypeEnum.PAYOUT:
      return (
        <h2 color="blue-gray" className="font-normal items-center flex flex-row">
          Pay-out
        </h2>
      );
    case TransactionTypeEnum.INSTANT_PAY:
      return (
        <h2 color="blue-gray" className="font-normal items-center flex flex-row">
          Instant Pay
        </h2>
      );
    case TransactionTypeEnum.SUBSCRIPTION:
      return (
        <h2 color="blue-gray" className="font-normal items-center flex flex-row">
          Subscription Earning
        </h2>
      );
    default:
      return null;
  }
};

export default TransactionType;
